import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PhotoSource } from '@fc-vehicles/components/dialogs/vehicle-photo-upload-dialog/uploaded-list/photo.source';

@Injectable({
  providedIn: 'root',
})
export class VehiclePhotosService {
  private tempFiles$: BehaviorSubject<PhotoSource[]> = new BehaviorSubject<
    PhotoSource[]
  >([]);

  get tempFiles() {
    return this.tempFiles$.getValue();
  }

  get tempFilesObs$() {
    return this.tempFiles$.asObservable();
  }

  addTempFiles(files: PhotoSource[]) {
    this.tempFiles$.next([...this.tempFiles, ...files]);
  }

  removePhoto(index: number) {
    this.tempFiles.splice(index, 1);
  }

  changeMainPhoto(index: number) {
    this.tempFiles.forEach((source, i) => (source.isPrimary = i === index));
  }

  clearTempFiles() {
    this.tempFiles$.next([]);
  }
}
